import Link from "next/link";

/**
 * Final CTA block used on solution detail pages; reusable for blog detail.
 */
function SolutionStyleFinalCta({
  heading = "Looking for similar solutions?",
  buttonText = "Let's build yours",
  buttonHref = "/contact",
}) {
  return (
    <section className="theme-band-dark border-t border-[#1e3d3a] py-12 md:py-14">
      <div className="container max-w-7xl">
        <div className="mx-auto max-w-3xl text-center">
          <h2 className="syne-font mb-5 text-2xl font-semibold leading-tight text-white sm:text-3xl lg:text-4xl">
            {heading}
          </h2>
          <Link
            href={buttonHref}
            className="solution-main-cta inline-block rounded-full border border-[#1c8c80] px-7 py-3 text-base font-semibold text-[#5aada4] no-underline transition-all hover:border-[#1c8c80] hover:bg-[#1c8c80] hover:text-white"
          >
            {buttonText}
          </Link>
        </div>
      </div>
    </section>
  );
}

export default SolutionStyleFinalCta;
